import { render, staticRenderFns } from "./ViewShipment.vue?vue&type=template&id=42aa48f6"
import script from "./ViewShipment.vue?vue&type=script&lang=js"
export * from "./ViewShipment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../ClientApp/wwwroot/dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports